import * as React from 'react'

const ArrowLeft = (props: { className?: string }) => (
  <svg
    className={'icon' + props.className}
    width='13'
    height='11'
    viewBox='0 0 13 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.138428 5.82983L4.323 9.98413C4.50757 10.1384 4.78394 10.1384 4.96948 9.98413L5.64624 9.30737C5.74292 9.21069 5.78882 9.08179 5.78394 8.95386C5.78003 8.83569 5.73413 8.71851 5.64624 8.63062L3.46851 6.49976H12.4998C12.6619 6.49976 12.8054 6.42261 12.8972 6.30347C12.9617 6.21948 12.9998 6.11401 12.9998 5.99976V4.99976C12.9998 4.80444 12.8884 4.63647 12.7263 4.55347C12.658 4.51929 12.5808 4.49976 12.4998 4.49976H3.45874L5.67651 2.35327C5.86108 2.1687 5.86108 1.86108 5.67651 1.67651L4.99976 0.999756C4.81519 0.815186 4.50757 0.815186 4.323 0.999756L0.138428 5.15308C-0.0461426 5.33765 -0.0461426 5.64526 0.138428 5.82983Z'
      fill='#405264'
    />
  </svg>
)

export default ArrowLeft



// WEBPACK FOOTER //
// ./src/components/icons/entity-icons/ArrowLeft.tsx